import { Component, Input } from "@angular/core";
import { AgentInfo } from "@app/core/models/agent";

@Component({
  selector: "main-header",
  templateUrl: "./main-layout-header.template.html"
})
export class MainLayoutHeaderComponent {
  public image_src: string = "./assets/images/logo green full.png";
  @Input() agent: AgentInfo;
}



// WEBPACK FOOTER //
// ./src/app/shared/common/layout/main-layout-header/main-layout-header.component.ts